import { render, staticRenderFns } from "./ItemFilterHomeLayout.vue?vue&type=template&id=0c498a9a&scoped=true&"
import script from "./ItemFilterHomeLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterHomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c498a9a",
  null
  
)

export default component.exports